import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  width: "25",
  height: "24",
  viewBox: "0 0 25 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createStaticVNode("<g clip-path=\"url(#clip0_102_6350)\"><path d=\"M4.28137 5.99141H21.3139M17.686 3.34738V8.81991\" stroke=\"#303333\" stroke-linecap=\"round\"></path><path d=\"M4.28137 18.6583H21.3139M17.686 16.0143V21.4868\" stroke=\"#303333\" stroke-linecap=\"round\"></path><path d=\"M21.314 12.5093L4.28148 12.5093M7.90934 15.1533L7.90934 9.68076\" stroke=\"#303333\" stroke-linecap=\"round\"></path></g><defs><clipPath id=\"clip0_102_6350\"><rect width=\"24\" height=\"24\" fill=\"white\" transform=\"translate(0.643555)\"></rect></clipPath></defs>", 2)
  ])))
}
export default { render: render }